import { ICheckbox, ICheckboxChangeArgs } from '@app/interfaces/checkbox';
import { IObservable, BehaviorSubject, ISubject, Subject } from '@app/utils/observable';
import { CheckboxComponent } from '../common/form/checkbox';

export class MemberCardCheckboxComponent extends CheckboxComponent<number> {
    public readonly element: HTMLElement;
    public readonly assemblyId: number;

    public get onChange$(): IObservable<MemberCardCheckboxComponent, ICheckboxChangeArgs<number>> {
        return this.changeEventSubject as ISubject<MemberCardCheckboxComponent, ICheckboxChangeArgs<number>>;
    }

    constructor(element: HTMLElement) {
        const checkbox = element.querySelector("input[type=checkbox]") as HTMLInputElement;
        super(checkbox);

        this.element = element;

        const assemblyIdValue = checkbox.dataset.assemblyId as string;
        this.assemblyId = assemblyIdValue === null || assemblyIdValue === "" ? 0 : parseInt(assemblyIdValue);
    }

    clone(idPrefix: string) {
        const $element = $(this.element).clone();

        $("[id]", $element).each((i, element) => {
            element.id = `${idPrefix}_${element.id}`;
        });
        $("[for]", $element).each((i, element) => {
            const label = element as HTMLLabelElement;
            label.htmlFor = `${idPrefix}_${label.htmlFor}`;
        });
        $("[name]", $element).each((i, element) => {
            element.removeAttribute("name");
        });

        return new MemberCardCheckboxComponent($element[0]);
    }

    set outlineOnChecked(value: boolean) {
        $(this.element).toggleClass("member-card-checkbox--outline-on-checked", value);
    }
}